<!--

 -->

<template>
  <div class="gsl-hrm-buzz-profile-image">
    <img alt="profile picture" :src="imageSrc" class="employee-image" />
  </div>
</template>

<script>
export default {
  name: 'ProfileImage',
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  computed: {
    imageSrc() {
      return `../pim/viewPhoto/empNumber/${this.employee.empNumber}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.gsl-hrm-buzz-profile-image {
  & img {
    width: 45px;
    height: 45px;
    display: flex;
    flex-shrink: 0;
    border-radius: 100%;
    box-sizing: border-box;
    justify-content: center;
  }
  .employee-image {
    width: 45px; /* Allow the image to fill the width of the container */
    height: 45px; /* Maintain aspect ratio */

    object-position: top;

    object-fit: cover; /* Ensures the image is cropped to fill the container */
  }
}
</style>
